import { render, staticRenderFns } from "./ThemedIconTextChip.vue?vue&type=template&id=3e8a3e40&scoped=true&"
import script from "./ThemedIconTextChip.vue?vue&type=script&lang=js&"
export * from "./ThemedIconTextChip.vue?vue&type=script&lang=js&"
import style0 from "./ThemedIconTextChip.vue?vue&type=style&index=0&id=3e8a3e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a3e40",
  null
  
)

export default component.exports